import { API, MapBoxAPI } from 'api';
import { ENV } from 'shared/ENV';
import { MapSearchApi } from 'shared/types';
import { MapSearchResult } from 'hooks/useMapSearch/useMapSearch.types';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { fetchGoogleMapsSearch } from 'hooks/useMapSearch';

type GoogleCoordsData = {
  coords: [lng: number, lat: number];
  formattedAddress: string;
};

/** @deprecated by `getGoogleCoords()` in `useMapSearch()` */
export const getGoogleCoords = async (
  placeId: string,
): Promise<GoogleCoordsData | null> => {
  if (!window.google) {
    return null;
  }

  const geocoder = new window.google.maps.Geocoder();
  const { results } = await geocoder.geocode({ placeId });

  const place = results[0];

  if (!place) {
    return null;
  }

  return {
    coords: [place.geometry.location.lng(), place.geometry.location.lat()],
    formattedAddress: place.formatted_address,
  };
};

/** @deprecated by `fetchMapboxSearch()` in `useMapSearch()` */
export const fetchLocations = async (
  term: string,
  proximity: string,
  searchApi: MapSearchApi,
): Promise<MapSearchResult[]> => {
  if (searchApi === 'google') {
    return fetchGoogleMapsSearch(term, proximity);
  }

  const res = await MapBoxAPI.get<{
    type: 'FeatureCollection';
    query: string[];
    features: MapSearchResult[];
  }>(`/${encodeURIComponent(term)}.json`, {
    params: {
      access_token: ENV.VITE_MAPBOX_ACCESS_TOKEN ?? '',
      proximity,
      types:
        'country,region,district,postcode,locality,place,address,poi,neighborhood',
      language: 'en',
      limit: '5',
      country: 'us',
    },
  });

  return res.data.features;
};

/** @deprecated by `fetchGeoEventsForSearch()` in `useMapSearch()` */
export const fetchGeoEvents = async (term: string): Promise<Wildfire[]> => {
  const params = new URLSearchParams({
    q: term,
    limit: '10',
    reporter_managed_only: 'false',
  });
  const res = await API.get(`geo_events/search?${params.toString()}`);
  return res.data.results;
};
